import React from 'react';
import { Link } from 'react-router-dom';
import PageTemplate from '../../components/PageTemplate/PageTemplate';
import { P } from '../../components/ui';
import { useFormConfig } from '../../hooks/useFormConfig';

function Error404Screen() {
  const { tenant } = useFormConfig();
  return (
    <PageTemplate>
      <h1 className="govuk-heading-l">Something has gone wrong!</h1>
      <P>Sorry, there is a problem with the service. Try again later.</P>
      <P>
        Return to{' '}
        <Link data-testid="default-error-overview-link" to={tenant ? `/${tenant}` : '/'}>
          Your questionnaire
        </Link>{' '}
        page.
      </P>
    </PageTemplate>
  );
}

export default Error404Screen;
